module.exports = __webpack_public_path__ + "img/selected4-min.e8284709.png";